import React, { useState, useEffect } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { Carousel } from 'react-responsive-carousel';
import { Editor, EditorState, ContentState, convertFromRaw } from 'draft-js';
import _ from 'lodash';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import placeholderImage from '../../../../assets/images/placeholder.jpg';
import { newFetch, GET } from '../../../../helpers/fetch';
import { config } from '../../../../config/index';
import placeholderBackground from '../../../../assets/images/placeholder-background.png';

const { SERVER_URL } = config;

function ItemDetail({
  history,
  match: {
    params: { item_id },
  },
}) {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const [item, setItem] = useState(null);
  const [quantityLeft, setQuantityLeft] = useState(0);
  const [totalRedeemed, setTotalRedeemed] = useState(0);

  useEffect(() => {
    if (item) {
      let total = item.redeemed.reduce(
        (total, redeem) => total + redeem.quantity,
        0
      );
      setQuantityLeft(item.quantity - total);
      setTotalRedeemed(total);
    }
  }, [item]);

  function isJSON(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  const fetchItem = async () => {
    let api_path = `/reward/${item_id}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setItem(response.results);

      isJSON(response.results.description)
        ? setEditorState(
            EditorState.createWithContent(
              convertFromRaw(JSON.parse(response.results.description))
            )
          )
        : setEditorState(
            EditorState.createWithContent(
              ContentState.createFromText(response.results.description)
            )
          );
    }
  };

  useEffect(() => {
    fetchItem();
  }, []);

  return (
    <>
      {item && (
        <div style={{ paddingTop: '3rem', marginBottom: '6rem' }}>
          <div
            className="d-flex flex-column"
            style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
          >
            <NavLink
              to="/rewards"
              className="text-decoration-none"
              style={{ color: 'inherit' }}
            >
              <div style={{ color: '#5156BE' }}>
                <i className="fas fa-chevron-left pe-2"></i>Back to Rewards
              </div>
            </NavLink>
            <div className="d-flex justify-content-between pt-4">
              <h5>{item ? item.name : ''}</h5>
              <button
                className="btn btn-brand adjust-fs adjust-shadow"
                style={{ width: '150px' }}
                onClick={() => history.push(`${item_id}/edit`)}
              >
                Edit Item
              </button>
            </div>
          </div>
          <div
            className="d-flex"
            style={{
              marginTop: '2rem',
              marginLeft: '3rem',
              marginRight: '3rem',
            }}
          >
            <div className="flex-grow-1">
              <div className="rounded adjust-shadow bg-white">
                <div className="p-4 d-flex flex-column">
                  <div className="d-flex flex-column">
                    <div>
                      {
                        <Carousel showStatus={false} showThumbs={false}>
                          {item.images.length > 0 ? (
                            item.images.map((image, index) => (
                              <div
                                key={index}
                                style={{ height: '350px' }}
                                className="bg-white"
                              >
                                <img
                                  style={{ maxWidth: '100%', height: '100%' }}
                                  src={`${SERVER_URL}/${image.url}`}
                                  alt=""
                                />
                              </div>
                            ))
                          ) : (
                            <div>
                              <img
                                src={placeholderBackground}
                                alt="Placeholder"
                              />
                            </div>
                          )}
                        </Carousel>
                      }
                    </div>
                    <div className="d-flex justify-content-between align-items-center my-3">
                      <div className="d-flex flex-column">
                        <div className="text-muted">Points to Redeem</div>
                        <h5 className="text-brand">
                          {item.type === 'redeemable'
                            ? `${item.redeem_points} POINTS`
                            : 'FREE'}
                        </h5>
                      </div>
                      <div
                        className="badge bg-brand text-white d-flex align-items-center justify-content-center"
                        style={{
                          height: '40px',
                          width: '120px',
                          borderRadius: '3.5rem',
                        }}
                      >
                        {quantityLeft} left
                      </div>
                    </div>
                    <div className="pt-2 text-muted">Status</div>
                    <p
                      className={`pt-2 ${
                        item.active ? 'text-success' : 'text-danger'
                      }`}
                    >
                      {item.active ? 'Active' : 'Inactive'}
                    </p>
                    <div className="pt-2 text-muted">Description</div>
                    <div className="pt-2"></div>
                    <div className="pt-2">
                      <Editor editorState={editorState} readOnly={true} />
                    </div>
                    <div className="pt-2 text-muted">Mailing Cost</div>
                    <p className="pt-2">{item.mailing_cost} Points</p>
                    <div className="pt-2 text-muted">
                      Instructions (How to Redeem)
                    </div>
                    <p className="pt-2">{item.instructions}</p>
                    <div className="pt-2 text-muted">Where to Collect</div>
                    <p className="pt-2">{item.collection_point}</p>
                    <div className="pt-2 text-muted">Remarks</div>
                    <p className="pt-2">{item.remarks}</p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="d-flex flex-column"
              style={{ minWidth: '250px', width: '250px', marginLeft: '2rem' }}
            >
              <strong className="mt-2">
                Redeemed ({totalRedeemed}){/* redeem > cart > associate */}
              </strong>
              {item &&
                item.redeemed.length > 0 &&
                item.redeemed.map(({ cart: { associate } }, index) => (
                  <div
                    // key={
                    //   associate !== null && associate.id !== undefined
                    //     ? associate.id
                    //     : 0
                    // }
                    key={index}
                    className="d-flex align-items-center my-1 py-1 rounded"
                    style={{ cursor: 'pointer' }}
                    onClick={() =>
                      history.push(`/associates/associate/${associate.id}`)
                    }
                  >
                    <div className="mx-2">
                      <img
                        className="img-responsive rounded-circle border"
                        src={
                          associate !== null &&
                          associate !== undefined &&
                          associate.image
                            ? `${SERVER_URL}/${associate.image}`
                            : placeholderImage
                        }
                        alt="username-img"
                        style={{ height: '35px', width: '35px' }}
                      />
                    </div>
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <div>
                        {_.truncate(
                          `${
                            associate !== null && associate !== undefined
                              ? associate.first_name
                              : 'Deleted Associate'
                          } ${
                            associate !== null && associate !== undefined
                              ? associate.last_name
                              : ''
                          }`,
                          { length: 18 }
                        )}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default withRouter(ItemDetail);
